/**
 * API definition for Common AiStudio Interfaces
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TrainingStatus = 'TRAINED' | 'TRAINING' | 'CANCELED' | 'NOT_STARTED' | 'FAILED';

export const TrainingStatus = {
    Trained: 'TRAINED' as TrainingStatus,
    Training: 'TRAINING' as TrainingStatus,
    Canceled: 'CANCELED' as TrainingStatus,
    NotStarted: 'NOT_STARTED' as TrainingStatus,
    Failed: 'FAILED' as TrainingStatus
};

